module.exports = __webpack_public_path__ + "img/S.f6eac2d.webp";